module.exports = __webpack_public_path__ + "static/media/icon-preavis.679bb9ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-preavis.svg
// module id = 619
// module chunks = 0